import type { BootstrapVueOptions } from "bootstrap-vue-next";

// bootstrap-vue-next setup, shared by main.ts and the test setup so specs
// render components with the same defaults as the app.
export const BOOTSTRAP_OPTIONS: BootstrapVueOptions = {
  components: true,
  directives: true,
  plugins: {
    components: {
      // Every BModal's built-in footer (AppModal and plain <BModal>) matches
      // ConfirmDialog and the hand-built modals: small light Cancel, small
      // action button.
      BModal: { cancelVariant: "light", buttonSize: "sm" },
      // BModal draws its backdrop with a BOverlay — by default bg-dark at
      // 85% with a 2px blur. The theme sets --bs-dark to $gray-100 in dark
      // mode, so that washed the page out milky white. Black at 50% with no
      // blur instead, like the Bootstrap .modal-backdrop the hand-built
      // modals and the LMS use. (bgColor replaces the variant class; "" not
      // null, since a null default falls back to the 2px blur.)
      BOverlay: { bgColor: "#000", opacity: 0.5, blur: "" },
    },
  },
};
